// @ts-nocheck

import { createAction, createSlice } from '@reduxjs/toolkit';
import { mdmApi } from '../lib/api';
export const FETCH_MDM_NODE = 'vehicles/mdm-node/fetch';
export const CLEAN_MDM_NODE = 'vehicles/mdm-node/clean';
export const ADD_MDM_NODE = 'vehicles/mdm-node/add';
export const UPDATE_MDM_NODE = 'vehicles/mdm-node/update';
const initialState = null;
const fetchMdmNodeAction = createAction(FETCH_MDM_NODE);
const cleanMdmNodeAction = createAction(CLEAN_MDM_NODE);
const addMdmNodeAction = createAction(ADD_MDM_NODE);
const updateMdmNodeAction = createAction(UPDATE_MDM_NODE);
const mdmNodeSlice = createSlice({
  name: 'mdmNode',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchMdmNodeAction, (state, {
      payload
    }) => payload).addCase(addMdmNodeAction, (state, {
      payload
    }) => payload).addCase(updateMdmNodeAction, (state, {
      payload
    }) => payload).addCase(cleanMdmNodeAction, () => initialState);
  }
});
export const mdmNodeActions = {
  fetch: fetchMdmNodeAction,
  clean: cleanMdmNodeAction,
  add: addMdmNodeAction,
  update: updateMdmNodeAction
};
export const fetchMdmNode = guid => async dispatch => {
  const mdmNode = await mdmApi.fetchMdmNode(guid);
  dispatch(mdmNodeActions.fetch(mdmNode));
};
export const cleanMdmNode = () => dispatch => dispatch(mdmNodeActions.clean());
export const addMdmNode = node => async dispatch => {
  const added = await mdmApi.addMdmNode(node);
  dispatch(mdmNodeActions.add(added));
};
export const updateMdmNode = node => async dispatch => {
  const updated = await mdmApi.updateMdmNode(node);
  dispatch(mdmNodeActions.update(updated));
};
export default mdmNodeSlice.reducer;
